import { render, staticRenderFns } from "./MatrixPreview.vue?vue&type=template&id=2299f494&lang=pug&"
import script from "./MatrixPreview.vue?vue&type=script&lang=js&"
export * from "./MatrixPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports